import { LICENSE_TYPES_CACHE_ACTIONS } from '../../constants/actions';
import { LicenseTypeDetail } from '../../types/api/LicenseTypesTypes';

export const cacheLicenseTypes = (licenseTypes: Array<LicenseTypeDetail>) => ({
  type: LICENSE_TYPES_CACHE_ACTIONS.CACHE_LICENSE_TYPES,
  licenseTypes,
});
